import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';

import { LoadingPage } from '@foradevelopment/fora-ui';
import { ThunkRequestStatus } from '@fora-monorepo/webapp-types';

import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { getToken, refreshToken } from '../../redux/auth/authThunks';
import { EmployerMyPagesErrorPage } from '../../components';

const authCodeSearchParam = 'authorizationCode';
const codeChallengeSearchParam = 'codeChallenge';
const selectedOrganizationSearchParam = 'selectedOrg';

export const Authentication = () => {
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const loading = useAppSelector(state => state.auth.loadingGetToken);
  const thunkError = useAppSelector(state => state.error.thunkError);

  useEffect(() => {
    const clearAuthSearchParams = () => {
      searchParams.delete(authCodeSearchParam);
      searchParams.delete(codeChallengeSearchParam);
      searchParams.delete(selectedOrganizationSearchParam);
      setSearchParams(searchParams);
    };

    const authCode = searchParams.get(authCodeSearchParam);
    const codeChallenge = searchParams.get(codeChallengeSearchParam);
    if (authCode && codeChallenge) {
      dispatch(getToken({ authCode, codeChallenge }));
      clearAuthSearchParams();
    } else {
      dispatch(refreshToken());
    }
    // We don't need to add searchParams as a dependency here,
    // as they are defined before the react app is rendered
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading === ThunkRequestStatus.Pending && <LoadingPage animation="spinner" />}
      {/* In theory loading can be ThunkRequestStatus.Fulfilled but we don't have a valid accessToken.
      This would mean we are not properly authenticated and thus we should present an ErrorPage.
      This is why the condition is loading !== ThunkRequestStatus.Pending and not loading !== ThunkRequestStatus.Rejected */}
      {loading !== ThunkRequestStatus.Pending && (
        <EmployerMyPagesErrorPage type={thunkError?.code} technicalError={thunkError?.message} />
      )}
    </>
  );
};
